import React, { useEffect, useState } from "react";
import "./App.css";
import HomePage from "./HomePage";
import PlinkoGame from "./games/plinko/PlinkoGame";
import EscolheBemGame from "./games/escolhe-bem/EscolheBemGame";
import LabirintoEquilibrioGame from "./games/labirinto-equilibrio/LabirintoEquilibrioGame";
import QuizGame from "./games/quiz/QuizGame";
import PuzzleGame from "./games/puzzle/PuzzleGame";
import HealthRushGame from "./games/health-rush/HealthRushGame";
import { ALL_PRODUCT_PATHS, byTags } from "./products/catalog.generated";

type GameId = "home" | "plinko" | "escolhe-bem" | "labirinto-equilibrio" | "quiz" | "puzzle" | "health-rush";

const ESCOLHE_BEM_WEBP_PATHS = byTags("healthy", "unhealthy", "escolhe-bem-victory").map(
  (p) =>
    `/images/products-escolhe-bem/${p.split("/").pop()!.replace(/\.[^.]+$/, ".webp")}`,
);

const UI_IMAGE_PATHS = [
  "/images/background.png",
  "/images/background4.png",
  "/images/bola.png",
  "/images/continente-footer.png",
  "/images/continente.png",
  "/images/alimenta-a-pedalada.png",
  "/images/continente-footer-2.png",
  "/images/joga-e-ganha-transparent.png",
  "/images/recarrega-te.png",
  "/images/volta.png",
  "/images/quiz/fundo.png",
  "/images/quiz/fundo-pergunta.png",
  "/images/affidea-day/affidea-day-on-tour.png",
  "/images/affidea-day/affidea-saude.svg",
  "/images/affidea-day/fundo-azul.webp",
  "/images/affidea-day/puzzle-bordado.webp",
  "/images/affidea-day/fundo-festival.webp",
  // Health Rush draws these on a canvas via new Image(), so they must be cached for offline use.
  ...["mri", "ct", "mamografo", "virus", "virus-desfocado-1", "virus-desfocado-2"].map(
    (name) => `/images/affidea-day/health-rush/${name}.webp`,
  ),
];

const ALL_IMAGES_TO_PRECACHE = [
  ...UI_IMAGE_PATHS,
  ...(ALL_PRODUCT_PATHS as string[]),
  ...ESCOLHE_BEM_WEBP_PATHS,
];

function App() {
  const [currentGame, setCurrentGame] = useState<GameId>("home");

  useEffect(() => {
    if (!navigator.onLine || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready.then(() => {
      ALL_IMAGES_TO_PRECACHE.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    });
  }, []);

  useEffect(() => {
    const titleMap: Record<GameId, string> = {
      home: "Início",
      plinko: "Plinko",
      "escolhe-bem": "Escolhe Bem",
      "labirinto-equilibrio": "Labirinto do Equilíbrio",
      quiz: "Quiz Palex",
      puzzle: "Sliding Puzzle",
      "health-rush": "Health Rush",
    };
    document.title = titleMap[currentGame];
  }, [currentGame]);

  const handleSelectGame = (gameId: string) => {
    if (
      gameId === "plinko" ||
      gameId === "escolhe-bem" ||
      gameId === "labirinto-equilibrio" ||
      gameId === "quiz" ||
      gameId === "puzzle" ||
      gameId === "health-rush"
    ) {
      setCurrentGame(gameId);
    }
  };

  const handleBackToHome = () => {
    setCurrentGame("home");
  };

  return (
    <div className="app">
      {currentGame === "home" ? (
        <HomePage onSelectGame={handleSelectGame} />
      ) : currentGame === "plinko" ? (
        <PlinkoGame onBackToHome={handleBackToHome} />
      ) : currentGame === "escolhe-bem" ? (
        <EscolheBemGame onBackToHome={handleBackToHome} />
      ) : currentGame === "labirinto-equilibrio" ? (
        <LabirintoEquilibrioGame onBackToHome={handleBackToHome} />
      ) : currentGame === "quiz" ? (
        <QuizGame onBackToHome={handleBackToHome} />
      ) : currentGame === "puzzle" ? (
        <PuzzleGame onBackToHome={handleBackToHome} />
      ) : currentGame === "health-rush" ? (
        <HealthRushGame onBackToHome={handleBackToHome} />
      ) : null}
    </div>
  );
}

export default App;
